import { render, staticRenderFns } from "./CertificateHistorical.vue?vue&type=template&id=7888e86a&scoped=true"
import script from "./CertificateHistorical.vue?vue&type=script&lang=js"
export * from "./CertificateHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7888e86a",
  null
  
)

export default component.exports